import { render, staticRenderFns } from "./confirm_result.vue?vue&type=template&id=25603f0a&scoped=true&"
import script from "./confirm_result.vue?vue&type=script&lang=js&"
export * from "./confirm_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25603f0a",
  null
  
)

export default component.exports